export const POSTCARD_UPSELL_EXCLUDED_SKUS = [
  'tec043-p',
  'grtz1142762490-p',
  'grtz3000039918-p',
  'bel034-p',
  'grtz1142762421-p',
  'grtz3000039568-p',
  'grtz1142770272-p',
  'rtr017-p',
  'grtz25q40103-p',
  'grtz25q40114-p',
  'kin022-p',
  'jsa003-p',
  'grtz1142752338-p',
  'lle010-p',
  'hlb038-p',
  'grtz26q20003-at-p',
  'grtz26q20001-na-p',
  'grtz25q40097-p',
  'grtz25q40113-p',
  'grtz3000039913-p',
  'grtz1142762445-p',
  'grtz3000044183-p',
  'dagbroo23q30006-na-p',
  'slo043-p',
  'kin017-p',
  'tec047-p',
  'tec050-p',
  'grtz25q40104-p',
  'tec049-p',
  'grtz3000039923-p',
  'grtz25q40107-p',
  'grtz25q40108-p',
  'bmg009-p',
  'grtz1142752452-p',
  'grtz3000005585-p',
  'am021-p',
  'grtz1142769960-p',
  'grtz1142747497-p',
  'grtz25q40111-p',
  'grtz25q40110-p',
  'grtz3000046273-p',
  'grtz26q20005-fk-p',
  'grtz3000091601-p',
  'grtz25q40109-p',
  'grtz25q40094-p',
  'lday110-p',
  'tec041-p',
  'grtz25q40096-p',
  'tec035-p',
  'grtz3000044068-p',
  'grtz1142752707-p',
  'grtz3000039578-p',
  'wdp014-p',
  'grtz1142743687-p',
  'grtz1142747605-p',
  'grtz25q40098-p',
  'grtz1142752710-p',
  'tec037-p',
  'grtz3000004622-p',
  'grtz26q20004-fkat-p',
  'tec042-p',
  'grtz25q40099-p',
  'grtz25q40116-p',
  'grtz25q40112-p',
  'grtz3000091196-p',
  'bee099-p',
  'flc005-p',
  'grtz3000039573-p',
  'fla028-p',
  'tec036-p',
  'grtz3000039503-p',
  'stdpts23q30006-na-p',
  'am020-p',
  'fro101-p',
  'jsa014-p',
  'grtz25q40100-p',
  'bal002-p',
  'flk002-p',
  'grtz3000039538-p',
  'grtz25q40118-p',
  'grtz1142762484-p',
  'laj015-p',
  'grtz1142750635-p',
  'grtz26q20002-fkat-p',
  'grtz1142782737-p',
  'grtz26q20006-na-p',
  'tec045-p',
  'tec039-p',
  'sst123-p',
  'grtz3000039988-p',
  'tec038-p',
  'grtz1142782746-p',
  'grtz25q40102-p',
  'spp006-p',
  'jsa008-p',
  'grtz3000038353-p',
  'grtz3000038483-p',
  'pai030-p',
  'grtz25q40115-p',
  'grtz3000038453-p',
  'tec048-p',
  'bot008-p',
  'grtz3000044098-p',
  'grtz1142779601-p',
  'jsa005-p',
  'grtz25q40095-p',
  'lpp023-p',
  'tec046-p',
  'grtz25q40117-p',
  'grtz1142779604-p',
  'grtz3000039528-p',
  'tec040-p',
  'dmr015-p',
  'grtz26q20007-na-p',
  'grtz3000096471-p',
  'grtz25q40101-p',
  'grtz3000039808-p',
  'ljans23q30006-na-p',
  'tec044-p',
  'mng020-p',
  'kin013',
] as const
